import { getInputMaskByOpenApiSchemaProperty } from '@/utils'

import { countryRegionsCountryCodes } from '@/components/services/country-regions/utils'

import render from './render'

/**
 * Выбор кода страны со свободным вводом.
 * Список строится по словарю `countries.codes`, пункт списка показывает флаг,
 * код и название страны. Поиск и свободный ввод ограничены маской из описания
 * поля OpenAPI-схемы.
 */
export default {
  name: 'CountryCode',

  props: {
    /**
     * Код страны.
     *
     * @type {string}
     */
    value: String,

    /**
     * Описание поля кода страны из OpenAPI-схемы.
     * По `pattern` и `maxLength` строится маска ввода поиска.
     *
     * @type {object}
     * @default {}
     */
    property: {
      type: Object,
      default: () => {
        return {}
      }
    },

    /**
     * Признак обязательного поля: звёздочка в подписи и ошибка после ухода из пустого поля.
     * Обязательное поле нельзя очистить крестиком.
     *
     * @type {boolean}
     * @default false
     */
    required: Boolean,

    /**
     * Текст ошибки. Без блока details поле только подсвечивается ошибкой.
     *
     * @type {string}
     */
    error: String
  },

  computed: {
    /**
     * Пункты списка кодов стран.
     * Заголовок пункта - код страны, название страны выводится в пункте списка для понимания.
     *
     * @returns {{ title: string, value: string, country: string }[]}
     */
    items() {
      return countryRegionsCountryCodes.map(code => {
        return {
          title: code,
          value: code,
          country: this.getTranslate(`countries.codes.${code}`)
        }
      })
    },

    /**
     * Маска ввода поиска из описания поля.
     *
     * @returns {{ mask: RegExp, maskOptions: object }|{}} Опции маски или пустой объект без маски.
     */
    inputMask() {
      return getInputMaskByOpenApiSchemaProperty(this.property) || {}
    }
  },

  render
}
